import { render } from "./TaskA.vue?vue&type=template&id=70058a1a&ts=true"
import script from "./TaskA.vue?vue&type=script&lang=ts"
export * from "./TaskA.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__